export const isLocalhost = window.location.hostname.toLowerCase().includes('localhost');
